var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-icon",
    transform: "translate(-869.986 -670.468)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_209",
    "data-name": "Elipse 209",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(869.986 670.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_482",
    "data-name": "Trazado 482",
    d: "M886.986,672.3a11.22,11.22,0,0,0-11.208,11.207,12.928,12.928,0,0,0,.951,4.315,18.178,18.178,0,0,0,1.295,2.423l7.685,11.642a1.461,1.461,0,0,0,2.553,0l7.685-11.643a18.072,18.072,0,0,0,1.3-2.423,12.937,12.937,0,0,0,.95-4.315A11.22,11.22,0,0,0,886.986,672.3Zm9.041,15.01a16.5,16.5,0,0,1-1.181,2.209l-7.684,11.643c-.152.23-.2.23-.352,0l-7.685-11.643a16.613,16.613,0,0,1-1.18-2.209,11.741,11.741,0,0,1-.848-3.8,9.889,9.889,0,0,1,19.777,0A11.728,11.728,0,0,1,896.027,687.309Z",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_483",
    "data-name": "Trazado 483",
    d: "M886.986,677.574a5.933,5.933,0,1,0,5.933,5.933A5.941,5.941,0,0,0,886.986,677.574Zm0,10.547a4.614,4.614,0,1,1,4.614-4.614A4.62,4.62,0,0,1,886.986,688.121Z",
    fill: "#0050c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.f6c6cdba64761b52cfb7ab7941ade1b9.svg";
export { ForwardRef as ReactComponent };